import { Flex, Layout, Typography } from 'antd';
import { useState } from 'react';
import PastTripsList from './PastTripsList';
import TripListEmpty from '../../../assets/icons/past-trips-empty.svg';
import PastTripsContent from './PastTripsContent';
import PropTypes from 'prop-types';

const { Sider, Content } = Layout;
const { Title } = Typography;

const PastTrips = ({ setActiveKey }) => {
  const [selectedTrip, setSelectedTrip] = useState(null);

  return (
    <Layout className="layout-page">
      <Sider width="max-content" minWidth={360}>
        <PastTripsList
          selectedTrip={selectedTrip}
          setSelectedTrip={setSelectedTrip}
          setActiveKey={setActiveKey}
        />
      </Sider>
      <Content
        className="full-height"
        style={{
          marginLeft: '0.75rem',
        }}
      >
        <Flex gap={2} className="full-height">
          {selectedTrip === null ? (
            <Flex
              vertical
              justify="center"
              align="center"
              className="full-width"
              gap={58}
            >
              <Title level={3} strong style={{ marginTop: 16 }}>
                Select a trip to view details
              </Title>
              <img src={TripListEmpty} alt="No Trip Selected" />
            </Flex>
          ) : (
            <PastTripsContent
              selectedTrip={selectedTrip}
              setSelectedTrip={setSelectedTrip}
            />
          )}
        </Flex>
      </Content>
    </Layout>
  );
};

PastTrips.propTypes = {
  setActiveKey: PropTypes.func.isRequired,
};

export default PastTrips;
